import { render, staticRenderFns } from "./platInferHome.vue?vue&type=template&id=5bf6015e&scoped=true&"
import script from "./platInferHome.vue?vue&type=script&lang=js&"
export * from "./platInferHome.vue?vue&type=script&lang=js&"
import style0 from "./platInferHome.vue?vue&type=style&index=0&id=5bf6015e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf6015e",
  null
  
)

export default component.exports